(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-service"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-eligible-items-total]').forEach((element) => {
    const total = Number(element.textContent.trim());

    if (Number.isFinite(total)) {
      element.textContent = new Intl.NumberFormat('en-US').format(total);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  const featuredVariantImageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.preloadFeaturedVariantImages?.();
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px' });

  const equalizeFeaturedSwatchHeights = (scope = document) => {
    const grids = scope.matches?.('.product-grid') ? [scope] : [...scope.querySelectorAll('.product-grid')];
    grids.forEach((grid) => {
      const titles = [...grid.querySelectorAll('[data-featured-variant-card] .card__heading')];
      const swatchGroups = [...grid.querySelectorAll('[data-featured-variant-card] .featured-variant-card__swatches')];
      titles.forEach((title) => { title.style.minHeight = '0px'; });
      swatchGroups.forEach((group) => { group.style.minHeight = '0px'; });
      const tallestTitle = Math.max(0, ...titles.map((title) => title.scrollHeight));
      const tallestGroup = Math.max(0, ...swatchGroups.map((group) => group.scrollHeight));
      titles.forEach((title) => { title.style.minHeight = `${tallestTitle}px`; });
      swatchGroups.forEach((group) => { group.style.minHeight = `${tallestGroup}px`; });
    });
  };

  const initializeFeaturedVariantCards = (scope = document) => {
    scope.querySelectorAll('[data-featured-variant-card]:not([data-variant-picker-ready])').forEach((card) => {
      card.dataset.variantPickerReady = 'true';
      const variantsNode = card.querySelector('[data-featured-variants]');
      const form = card.querySelector('form');
      const variantInput = form?.querySelector('[name="id"]');
      const button = form?.querySelector('[name="add"]');
      const buttonLabel = button?.querySelector('[data-button-label]');
      const cardImage = card.querySelector('.card__media img');
      const sizeSelect = card.querySelector('select[data-option-position]');
      const colorInputs = [...card.querySelectorAll('input[type="radio"][data-option-position]')];
      if (!variantsNode || !variantInput || !button) return;
      const variants = JSON.parse(variantsNode.textContent);
      let imageRequest = 0;

      const variantImageWidth = () => {
        const requiredWidth = Math.ceil((cardImage?.getBoundingClientRect().width || 360) * window.devicePixelRatio);
        return [360, 533].find((width) => width >= requiredWidth) || 533;
      };

      const variantImageUrl = (variant) => {
        if (!variant?.featured_image?.src) return '';
        const url = new URL(variant.featured_image.src, window.location.origin);
        url.searchParams.set('width', variantImageWidth());
        return url.toString();
      };

      const baseImageUrl = (source) => {
        if (!source) return '';
        const url = new URL(source, window.location.origin);
        url.searchParams.delete('width');
        return url.toString();
      };

      const preloadVariantImages = () => {
        const urls = [...new Set(variants.map(variantImageUrl).filter(Boolean))];
        card.featuredVariantPreloads = urls.map((source) => {
          const image = new Image();
          image.decoding = 'async';
          image.fetchPriority = 'low';
          image.src = source;
          return image;
        });
      };

      const swapVariantImage = (variant) => {
        const source = variantImageUrl(variant);
        if (!cardImage || !source || baseImageUrl(cardImage.currentSrc || cardImage.src) === baseImageUrl(source)) return;
        const request = ++imageRequest;
        const image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'high';
        image.onload = () => {
          if (request !== imageRequest) return;
          cardImage.removeAttribute('srcset');
          cardImage.src = source;
          if (variant.featured_image.alt) cardImage.alt = variant.featured_image.alt;
        };
        image.src = source;
      };

      card.preloadFeaturedVariantImages = preloadVariantImages;
      card.addEventListener('pointerenter', preloadVariantImages, { once: true });
      card.addEventListener('focusin', preloadVariantImages, { once: true });
      featuredVariantImageObserver.observe(card);

      const selectedOptions = () => {
        const values = [];
        colorInputs.forEach((input) => { if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value; });
        if (sizeSelect) values[Number(sizeSelect.dataset.optionPosition) - 1] = sizeSelect.value;
        return values;
      };

      const refresh = (changedControl) => {
        let values = selectedOptions();
        let variant = variants.find((item) => item.options.every((value, index) => !values[index] || values[index] === value));
        if (changedControl?.matches('input[type="radio"]') && sizeSelect && (!variant || !variant.available)) {
          const sizePosition = Number(sizeSelect.dataset.optionPosition) - 1;
          const availableVariant = variants.find((item) => item.available && item.options.every((value, index) => index === sizePosition || !values[index] || values[index] === value));
          if (availableVariant) {
            sizeSelect.value = availableVariant.options[sizePosition];
            values = selectedOptions();
            variant = availableVariant;
          }
        }
        if (sizeSelect) {
          const sizePosition = Number(sizeSelect.dataset.optionPosition) - 1;
          [...sizeSelect.options].forEach((option) => {
            option.disabled = !variants.some((item) => item.available && item.options.every((value, index) => index === sizePosition ? value === option.value : !values[index] || values[index] === value));
          });
          const selectedSize = card.querySelector('[data-selected-size]');
          if (selectedSize) selectedSize.textContent = sizeSelect.value;
        }
        const selectedColor = card.querySelector('[data-selected-color]');
        const checkedColor = colorInputs.find((input) => input.checked);
        if (selectedColor && checkedColor) selectedColor.textContent = checkedColor.value;
        const available = Boolean(variant?.available);
        if (changedControl) swapVariantImage(variant);
        card.querySelectorAll('.card__heading a[href]').forEach((link) => {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          if (variant?.id) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          link.setAttribute('href', url.pathname + url.search + url.hash);
        });
        variantInput.value = variant?.id || '';
        variantInput.setAttribute('value', variant?.id || '');
        variantInput.disabled = !available;
        button.disabled = !available;
        if (buttonLabel) buttonLabel.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      };

      colorInputs.forEach((input) => input.addEventListener('change', () => refresh(input)));
      sizeSelect?.addEventListener('change', () => refresh(sizeSelect));
      refresh();
    });
    requestAnimationFrame(() => equalizeFeaturedSwatchHeights(scope));
  };
  initializeFeaturedVariantCards();
  let featuredSwatchResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(featuredSwatchResizeTimer);
    featuredSwatchResizeTimer = setTimeout(() => equalizeFeaturedSwatchHeights(), 100);
  });
  document.addEventListener('shopify:section:load', (event) => initializeFeaturedVariantCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-review"] && !Shopify.designMode) return;
  try {
    
  const initialiseFeaturedReviews = (scope) => {
    const sections = scope.matches && scope.matches('[data-featured-review]') ? [scope] : Array.from(scope.querySelectorAll('[data-featured-review]'));

    sections.forEach((section) => {
      if (section.dataset.featuredReviewReady === 'true') return;

      let reviewScrollPosition = window.scrollY;
      section.querySelectorAll('[data-featured-review-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          reviewScrollPosition = window.scrollY;
        });
      });


      const items = Array.from(section.querySelectorAll('[data-featured-review-item]'));
      const dotsContainer = section.querySelector('[data-featured-review-dots]');
      const viewport = section.querySelector('.featured-review__viewport');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayDelay = 5000;
      let currentIndex = 0;
      let autoplayTimer;
      let scrollTimer;
      let isHovering = false;
      let isInteracting = false;
      let isMouseDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;

      items.forEach((item) => {
        item.hidden = false;
        item.classList.add('is-active');
      });

      const renderDots = () => {
        if (!dotsContainer || !items.length) return;
        const lastIndex = items.length - 1;
        let positions = [0];

        if (lastIndex > 0 && currentIndex === 0) positions = [0, 1];
        else if (lastIndex > 0 && currentIndex === lastIndex) positions = [lastIndex - 1, lastIndex];
        else if (lastIndex > 0) positions = [currentIndex - 1, currentIndex, currentIndex + 1];

        dotsContainer.replaceChildren(...positions.map((position) => {
          const dot = document.createElement('span');
          dot.className = 'featured-review__dot';
          if (position === currentIndex) dot.classList.add('is-active');
          return dot;
        }));
      };

      const stopAutoplay = () => {
        window.clearTimeout(autoplayTimer);
      };

      const scheduleAutoplay = () => {
        stopAutoplay();
      };

      const showReview = (index, behavior = 'smooth') => {
        if (!items.length || !viewport) return;
        currentIndex = Math.min(items.length - 1, Math.max(0, index));
        const target = items[currentIndex];
        viewport.scrollTo({ left: target.offsetLeft - viewport.offsetLeft, behavior });
        renderDots();
        scheduleAutoplay();
      };

      const syncIndexFromScroll = () => {
        if (!viewport || !items.length) return;
        const viewportLeft = viewport.getBoundingClientRect().left;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - viewportLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        currentIndex = nearestIndex;
        renderDots();
        scheduleAutoplay();
      };

      viewport?.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncIndexFromScroll, 120);
      }, { passive: true });

      viewport?.addEventListener('pointerdown', (event) => {
        isInteracting = true;
        stopAutoplay();
        if (event.pointerType === 'mouse') {
          isMouseDragging = true;
          dragStartX = event.clientX;
          dragStartScrollLeft = viewport.scrollLeft;
        }
      });

      viewport?.addEventListener('pointermove', (event) => {
        if (!isMouseDragging) return;
        viewport.scrollLeft = dragStartScrollLeft - (event.clientX - dragStartX);
      });

      const finishInteraction = () => {
        isMouseDragging = false;
        isInteracting = false;
        window.setTimeout(syncIndexFromScroll, 160);
      };

      viewport?.addEventListener('pointerup', finishInteraction);
      viewport?.addEventListener('pointercancel', finishInteraction);

      section.addEventListener('mouseenter', () => {
        isHovering = true;
        stopAutoplay();
      });
      section.addEventListener('mouseleave', () => {
        isHovering = false;
        scheduleAutoplay();
      });
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', scheduleAutoplay);
      document.addEventListener('visibilitychange', scheduleAutoplay);

      section.addEventListener('shopify:block:select', (event) => {
        const selectedItem = event.target.closest('[data-featured-review-item]');
        if (selectedItem) showReview(Number(selectedItem.dataset.index));
      });

      reducedMotionQuery.addEventListener('change', scheduleAutoplay);
      showReview(0, 'auto');

      const modal = section.querySelector('[data-featured-review-modal]');
      const modalContent = section.querySelector('[data-featured-review-modal-content]');
      section.querySelectorAll('[data-featured-review-open]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const template = button.parentElement.querySelector('[data-featured-review-full]');
          if (!modal || !modalContent || !template) return;
          modalContent.replaceChildren(template.content.cloneNode(true));
          modal.showModal();
          document.body.style.overflow = 'hidden';
        });
      });
      section.querySelector('[data-featured-review-close]')?.addEventListener('click', () => modal?.close());
      modal?.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });
      modal?.addEventListener('close', () => { document.body.style.overflow = ''; });

      section.dataset.featuredReviewReady = 'true';
    });
  };

  initialiseFeaturedReviews(document);
  document.addEventListener('shopify:section:load', (event) => initialiseFeaturedReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  const initialiseProductFeatureReveal = (root) => {
    const sections = root.matches?.('.product-features') ? [root] : root.querySelectorAll?.('.product-features') || [];

    sections.forEach((section) => {
      if (!section.classList.contains('product-features--reveal') || section.dataset.revealInitialised === 'true') return;

      section.dataset.revealInitialised = 'true';
      const cards = section.querySelectorAll('.product-feature-card');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        cards.forEach((card) => card.classList.add('is-visible'));
        return;
      }

      section.classList.add('product-features--motion-ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.01, rootMargin: '-28% 0px -28% 0px' }
      );

      cards.forEach((card) => observer.observe(card));
    });
  };

  initialiseProductFeatureReveal(document);
  document.addEventListener('shopify:section:load', (event) => initialiseProductFeatureReveal(event.target));

  } catch(e) { console.error(e); }
})();
})();
